/**
 * 侧边导航栏
 */
// import Vue from 'vue';
import router from '../../router';
import {
  routes,
  notFound
} from '../../router';

import {
  TOGGLE_SIDEBAR,
  SET_MENUS,
  CURRENT_MENUS,
  SET_REGIONS
} from '../mutation.types'

import {
  arrayToTree
} from '../../util/util'
import {
  getMenus
} from '../../http/menu'
import {
  getRegionList
} from '../../http/region'

export default {
  state: {
    sidebar: {
      collapsed: false,
      show: true,
    },
    menuList: [],
    currentMenu: null,
    regionList: []
  },

  getters: {
    menuList(state) {
      return arrayToTree(state.menuList, 'id', 'parentId', 'children')
    },
    regionList(state) {
      return arrayToTree(state.regionList, 'id', 'parentId', 'children')
    }
  },
  mutations: {
    [TOGGLE_SIDEBAR](state) {
      state.sidebar.collapsed = !state.sidebar.collapsed
    },

    [SET_MENUS](state, menuList) {
      state.menuList = [...menuList]
      // Vue.set(state, 'menuList', menuList)
    },
    [CURRENT_MENUS](state, currentMenu) {
      state.currentMenu = currentMenu
    },
    // 区域
    [SET_REGIONS](state, regionList) {
      state.regionList = [...regionList]
    }
  },
  actions: {
    UPDATE_MENUS({
      commit
    }) {
      // dynamic routes: use router.addRoutes()
      return getMenus({
          roleIds: localStorage.roleIds
        })
        .then(res => res.rows)
        .then(menus => {
          // filter
          const newRoutes = routesFilter(routes, menus)
          router.addRoutes([...newRoutes, notFound])
          //   commit(SET_MENUS, menus)
          commit(SET_MENUS, menus.map(m => {
            if (m.isShow) return m;
          }))
          commit(CURRENT_MENUS, menus.find(m => m.parentId && (m.href === router.currentRoute.path)))
        })
    },
    UPDATE_REGIONS({
      commit
    }, query) {
      return getRegionList(query)
        .then(res => res.rows)
        .then(regions => {
          // console.log(regions)
          commit(SET_REGIONS, regions)
        })
    }
  }
}

function routesFilter(routes, menus) {
  const menuPaths = menus.map(menu => menu.href);
  const newRoutes = []
  routes[0].children.forEach(route => {
    if (menuPaths.includes(route.path) || !route.meta.isMenu) {
      newRoutes.push(route)
    }
  })
  return [{
    ...routes[0],
    children: newRoutes
  }]
}



// WEBPACK FOOTER //
// ./src/store/modules/sideNav.js